import DashboardLayout from '../layout/DashboardLayout.vue'
import LoginLayout from '../layout/LoginLayout.vue'
// GeneralViews
import NotFound from '../pages/NotFoundPage.vue'

// Admin pages
import Overview from 'src/pages/Overview.vue'
import UserProfile from 'src/pages/NewUser.vue'
import Users from 'src/pages/Users.vue'
import TableList from 'src/pages/TableList.vue'
import Typography from 'src/pages/Typography.vue'
import Icons from 'src/pages/Icons.vue'
import Maps from 'src/pages/Maps.vue'
import Notifications from 'src/pages/Notifications.vue'
import Upgrade from 'src/pages/Upgrade.vue'
import MoneyBoxes from 'src/pages/MoneyBoxes.vue'
import MoneyBoxNew from 'src/pages/MoneyBoxNew.vue'
import Segment from 'src/pages/Segment.vue'
import Segments from 'src/pages/Segments.vue'
import Corporation from 'src/pages/Corporation.vue'
import Corporations from 'src/pages/Corporations.vue'
import LoginPage from 'src/pages/LoginPage.vue'
import Unauthorized from 'src/pages/unauthorized.vue'

const routes = [
  {
    path: '/',
    component: DashboardLayout,
    redirect: '/admin/overview',
  },
  {
    path: '/unauthorized',
    component: Unauthorized,
  },
  {
    path: '/login',
    component: LoginLayout
  },
  {
    path: '/admin',
    component: DashboardLayout,
    redirect: '/admin/overview',
    meta: {
        requiresAuth: true
    },
    children: [
      {
        path: 'overview',
        name: 'Overview',
        component: Overview,
        meta: { requiredRoles: ['admin'], requiresAuth: true }
      },
      {
        path: 'user',
        name: 'User',
        component: UserProfile,
        meta: { requiredRoles: ['admin'], requiresAuth: true }
      },
      {
        path: 'users',
        name: 'Users',
        component: Users,
        meta: { requiredRoles: ['admin'], requiresAuth: true }
      },
      {
        path: 'money-boxes',
        name: 'MoneyBoxes',
        component: MoneyBoxes,
        meta: { requiredRoles: ['admin'], requiresAuth: true }
      },
      {
        path: 'money-box',
        name: 'MoneyBoxNew',
        component: MoneyBoxNew,
        meta: { requiredRoles: ['admin'], requiresAuth: true }
      },
      {
        path: 'segments',
        name: 'Segments',
        component: Segments,
        meta: { requiredRoles: ['admin'], requiresAuth: true }
      },
      {
        path: 'segment',
        name: 'Segment',
        component: Segment,
        meta: { requiredRoles: ['admin'], requiresAuth: true }
      },
      {
        path: 'corporations',
        name: 'Corporations',
        component: Corporations,
        meta: { requiredRoles: ['admin'], requiresAuth: true }
      },
      {
        path: 'corporation',
        name: 'Corporation',
        component: Corporation,
        meta: { requiredRoles: ['admin'], requiresAuth: true }
      },
      {
        path: 'table-list',
        name: 'Table List',
        component: TableList
      },
      {
        path: 'typography',
        name: 'Typography',
        component: Typography
      },
      {
        path: 'icons',
        name: 'Icons',
        component: Icons
      },
      {
        path: 'maps',
        name: 'Maps',
        component: Maps
      },
      {
        path: 'notifications',
        name: 'Notifications',
        component: Notifications
      },
      {
        path: 'upgrade',
        name: 'Upgrade to PRO',
        component: Upgrade
      }
    ]
  },
  { path: '*', component: NotFound }
]

/**
 * Asynchronously load view (Webpack Lazy loading compatible)
 * The specified component must be inside the Views folder
 * @param  {string} name  the filename (basename) of the view to load.
function view(name) {
   var res= require('../components/Dashboard/Views/' + name + '.vue');
   return res;
};**/

export default routes
